// extracted by mini-css-extract-plugin
module.exports = {"container":"UnloggedUserBox_container__1ci_3","textContainer":"UnloggedUserBox_textContainer__15Z8E"};